<template>
  <v-dialog
    v-model="openDetails"
    @click:outside="closeDetails()"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="600"
  >
    <v-card solid class="d-flex">
      <v-container class="pa-0 d-flex flex-column">
        <v-layout
            v-if="loading" class="pa-4">
        <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
        </v-layout>
        <template v-else-if="item">
          <v-layout column class="flex-none">
            <div
              flat
              class="details-header"
              :style="{
                'background-image':
                  'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(' +
                  item.activity.coverImageUrl +
                  ')',
              }"
            >
              <v-layout mt-2>
                <div class="details-title pa-1">
                  <v-icon
                    v-if="$vuetify.breakpoint.xsOnly"
                    @click="closeDetails()"
                    color="white"
                    class="ms-3"
                    >mdi-arrow-left</v-icon
                  >
                  <v-toolbar-title class="ms-3 pr-2">{{
                    item.activity.name
                  }}</v-toolbar-title>
                </div>
                <v-spacer />
                <v-icon
                  v-if="$vuetify.breakpoint.smAndUp"
                  @click="closeDetails()"
                  color="white"
                  class="ms-3 me-3"
                  >close</v-icon
                >
              </v-layout>
            </div>
          </v-layout>
          <reservation-details v-if="!displayOrder" :item="item" @displayOrder="displayOrder = true" @reload="reload"/>
          <reservation-order-details v-else :item="item" @displayReservation="displayOrder = false"/>
        </template>
        <v-layout v-else justify-center align-center pa-5>
          <v-progress-circular indeterminate />
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { reservationTypes } from '@/config'
import moment from 'moment'
import { ActivityReservationsRequests } from '@/services/activityReservations.requests'
const activityReservationsService = new ActivityReservationsRequests()

export default {
  data () {
    return {
      moment,
      reservationTypes,
      item: null,
      displayOrder: false,
      loading: false,
    }
  },
  components: {
    ReservationDetails: () => import('@/components/view-components/reservations/ReservationDetails.vue'),
    ReservationOrderDetails: () => import('@/components/view-components/reservations/ReservationOrderDetails.vue'),
  },
  methods: {
    closeDetails () {
      this.$emit('closeDetails')
    },
    reload () {
      this.$emit('reload')
      this.loading = true
      activityReservationsService
        .getReservation(this.reservationId)
        .then(async (response) => {
          this.item = response
        }).finally(() => {
          this.loading = false
        })
    },
  },
  watch: {
    openDetails: {
      immediate: true,
      handler: function () {
        if (this.openDetails) {
          return new Promise(() => {
            activityReservationsService
              .getReservation(this.reservationId)
              .then(async (response) => {
                this.item = response
              })
          })
        } else {
          this.displayOrder = false
        }
      },
    },
  },
  props: {
    openDetails: Boolean,
    reservationId: String,
  },
}
</script>

<style lang="scss">
.details-header {
  background-size: cover;
  background-position: center center;
  height: 135px !important;
  .details-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-flex;
    color: white;
    background: rgba(black, 0.5);
  }
}
.details-title {
  color: grey;
  font-size: 24px;
}
.details-data {
  color: grey;
  font-size: 18px;
}
.details-data-bold {
  font-weight: bold;
  color: grey;
  font-size: 18px;
}
</style>
